import Menu from "./menu";
import Options from "./options";
import PeriodicaForm from "./periodicaform";
import Pickup from "./pickup";
import Loanerform from "./loanerform";
import Receipt from "./receipt";
import Filter from "./filter";
import References from "./references";
import ManifestationContent from "./manifestationContent";
import Material from "./material";
import DeleteOrder from "./deleteOrder";
import AgencyLocalizations from "./agencyLocalizations";
import BranchLocalizations from "./branchLocalizations";
import BranchDetails from "./branchDetails";
import OrderHistoryDataConsent from "./orderHistoryDataConsent";
import Login from "./login";
import MitIDOnly from "./login/mitIDOnly";
import MobileLogin from "./mobileLogin";
import OpenAdgangsplatform from "./openAdgangsplatform";
import LoginNotSupported from "./loginNotSupported";
import AddLibrary from "./addLibrary";
import Verify from "./verify";
import StatusMessage from "./statusMessage";
import RemoveLibrary from "./removeLibrary";
import DeleteProfile from "./deleteProfile";
import EMaterialFilter from "./bookmarkOrder/EMaterialFilter";
import MultiOrder from "./bookmarkOrder/multi-order/MultiOrder.page";
import MultiReceipt from "./bookmarkOrder/receipt/MultiOrderReceipt.page";
import MultiReferences from "./references/multiReferences/MultiReferences";
import EditionPicker from "./references/editionPicker/EditionPicker";
import AccountHasProfile from "./accountHasProfile";
import AdvancedFacets from "./advancedFacets/AdvancedFacets.page";
import MobileFacets from "./advancedFacets/mobileFacets/mobileFacets.page";
import SaveSearch from "./saveSearch";

const _modal = {
  Menu,
  Options,
  PeriodicaForm,
  Pickup,
  Loanerform,
  Receipt,
  Filter,
  References,
  MultiReferences,
  EditionPicker,
  ManifestationContent,
  Material,
  DeleteOrder,
  AgencyLocalizations,
  BranchLocalizations,
  BranchDetails,
  OrderHistoryDataConsent,
  Login,
  MitIDOnly,
  MobileLogin,
  LoginNotSupported,
  OpenAdgangsplatform,
  AddLibrary,
  Verify,
  StatusMessage,
  RemoveLibrary,
  DeleteProfile,
  EMaterialFilter,
  MultiOrder,
  MultiReceipt,
  AccountHasProfile,
  AdvancedFacets,
  MobileFacets,
  SaveSearch,
};

export default _modal;
